import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IReportChallengeIssueRequest } from './report-challenge-issue-request';
import type { IReportChallengeIssueResponse } from './report-challenge-issue-response';
import { reportChallengeIssueResponseSchema } from './report-challenge-issue-response';

export async function reportChallengeIssueApi({
  challengeId,
  details,
  note,
  lang,
  clipUrl,
}: IReportChallengeIssueRequest): Promise<IValidatedResponse<IReportChallengeIssueResponse>> {
  return postRequest<IReportChallengeIssueResponse>({
    path: '/challenge-issues/report/v1',
    body: { challengeId, details, note, lang, clipUrl },
    schema: reportChallengeIssueResponseSchema,
  });
}
